import './content-section.component.scss'

const toc = document.querySelector('#ez-toc-container nav')

if (toc) {
	toc.addEventListener('scroll', () => toc.scrollTop ? toc.classList.add('js-active') : toc.classList.remove('js-active'))
}


const liItems = document.querySelectorAll('.content__body ul li')
liItems.forEach(item => {
	const children = item.children
	if (children.length > 0) {
		if (children[0].tagName.toLowerCase() === 'h3') {
			item.classList.add('with-title-h3')
		}
		if (children[0].tagName.toLowerCase() === 'h4') {
			item.classList.add('with-title-h4')
		}
	}
})
